// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ru-z","response":"Su-z","error":"Tu-z","disabled":"Uu-z","buttons":"Vu-z","feedbackQuestionSection":"Wu-z","yesNoWrapper":"Xu-z"};